<template>
    <div>
      <Header></Header>
      <div class="box">
      <div class="head-a">
        <img src="static/images/logo2.png" alt="">
      </div>
      <div class="content">
        <div>
          <h1>百度指数一键下载</h1>
          <div style="font-size:18px;">
            <p>百度指数采集，怎么下载数据，使用本站可以百度指数一键下载，告别四处求人，自己轻松导出百度指数到Excel，百度指数采集设置灵活，随心所欲的设置。数据采集结果直观。</p>
            <br>
            <h3>使用图解</h3>
            <img style="width:100%;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/index.jpg" alt="">
            <p>数据结果保存方式：每个词+地点为一个保存文件，里面会存储多年的数据结果</p>
            <p>点击<router-link to="/homeedit">搜索指数</router-link>进入采集页面</p>
            <!-- <p>当前只支持电脑端浏览器采集数据</p> -->
            <br>
            <br>
            <h3>数据结果样例</h3>
            <img style="width:60%;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/jieguo.png" alt="">
            <br>
            <br>
            <br>
            <br>
          </div>
          <a name="kz"><h1>扩展插件安装说明</h1></a>
          <br>
          <div style="font-size:18px;">
            <h3>第一步：扩展支持微软edge浏览器和chrome浏览器，如果有其中一个可跳过第一步</h3>
            <p>需要下载安装chrome浏览器的，点击下面链接</p>
            <p>点击<a target="_blank" href="https://www.google.cn/chrome/">去官方下载</a></p>
            <br>
            <h3>第二步：下载浏览器扩展插件包</h3>
            <p><a href="https://cmshj.oss-cn-beijing.aliyuncs.com/data/dtool.zip?v=1">点击这里下载</a></p>
            <p>将下载的dtool.zip解压，生成dtool目录</p>
            <br>
            <h3>第三步：安装扩展插件包</h3>
            <h4>edge浏览器安装方法</h4>
            <div>
                <p>1：打开刚刚安装的edge浏览器，在地址栏输入<span style="color: #0a73bb">edge://extensions</span>,如下图所示：</p>
                <p>2:开启"开发者模式"，如下图所示：</p>
                <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/edge_install1.jpg" style="width: 100%">
                <p>3:点击"加载已解压的扩展程序"，选择刚刚下载的"dtool"扩展插件包解压后的目录，如下图所示：</p>
                <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/edge_install2.jpg" style="width: 100%">
                <p>4:安装完成，刷新一下草莓数据网站在开始下载，如下图所示：</p>
                <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/edge_install3.jpg" style="width: 100%">
            </div>
            <br>
            <h4>chrome浏览器安装方法</h4>
            <div>
                <p>1：打开刚刚安装的chrome浏览器，在地址栏输入<span style="color: #0a73bb">chrome://extensions</span>,如下图所示：</p>
                <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/install1.jpg" style="width: 100%">
                <p>2:开启"开发者模式"，如下图所示：</p>
                <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/install2.jpg" style="width: 100%">
                <p>3:点击"加载已解压的扩展程序"，选择刚刚下载的"dtool"扩展插件包解压后的目录，如下图所示：</p>
                <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/install3.jpg" style="width: 100%">
                <p>4:安装完成，刷新一下草莓数据网站在开始下载，如下图所示：</p>
                <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/install4.jpg" style="width: 100%">
            </div>
            <br>
            <h3>第四步：开始使用</h3>
            <div>
              <p>进入网站首页，点击"开始使用"即可,如下图所示：</p>
              <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/install5.png" style="width: 100%">
            </div>
          </div>
          <br>
          <br>
          <br>
          <hr>
          <br>
          <h1>更新说明</h1>
          <br>
          <div style="font-size:18px;">
            <div class="install_doc" id="update">
            <div><h4>第一步：下载最新扩展插件包</h4></div>
            <div>
                <p><a href="https://cmshj.oss-cn-beijing.aliyuncs.com/data/dtool.zip?v=1">点击下载最新扩展插件包</a></p>
                <p>用解压后的最新扩展插件包目录替换掉原来的扩展插件包目录</p>
            </div>
            <br>
            <div><h4>第二步：重新加载工具包</h4></div>
            <div>
                <p>在地址栏输入<span style="color: #0a73bb">chrome://extensions/</span>,点击图示中的按钮，提示"已重新加载"即可完成更新。</p>
                <img src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/install6.png" style="width: 80%">
            </div>
        </div>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
import Header from './header'

export default {
  components: {
    Header
  },

  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@media (max-width: 768px){
  .box {
    width: 90vw !important;
  }
  .tx-box {
    margin: 0 !important;
  }
  .tb-box {
    margin: 40px 0 !important;
  }

}
a:hover {
  color: #177ff5;
}
a:link{color: #177ff5;}
a:visited{color: #177ff5;}
.box {
  margin: 60px auto;
  width: 60vw;
}
.head-a {
  background: #398dee;
  border-radius: 7px;
  padding: 20px;
}
.content {
  text-align: left;
  margin: 20px 0;
  padding: 20px;
}
.info {
  font-size: 18px;
  line-height: 34px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/intr_index.vue